document.addEventListener("DOMContentLoaded", function() {
    const detailsElement = document.getElementById("Details-menu-drawer-container");
    const hamburgerIcon = document.getElementById("icon-homburger");
    const menuItems = document.querySelectorAll('.menu-drawer__menu li');
    const menuClose = document.getElementById('icon-close');

    const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (detailsElement.hasAttribute('open')) {
                    menuItems.forEach(function(item, index) {
                        setTimeout(function() {
                            item.style.transition = "left 0.3s ease-in-out";
                            item.style.left = '0';
                            menuClose.style.left = '0';
                        }, index * 100);
                    });
                } else {
                    menuItems.forEach(function(item, index) {
                            item.style.transition = "left 0s ease-in-out";
                            item.style.left = '-100%';
                            menuClose.style.left = '-100%';
                    });
                    // console.log('open属性が外れました');
                }
            }
        });
    });

    observer.observe(detailsElement, { attributes: true });
});